import React from "react";
import PropTypes from "prop-types";

import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";

// import FeedbackIcon from "@mui/icons-material/Feedback";

export const ConfirmationDialog = (props) => {
  const {
    title,
    displayImage,
    children,
    alert,
    confirmBtnLabel,
    cancelBtnLabel,
    open,
    setOpen,
    onConfirm,
    onCancel,
  } = props;

  return (
    <Dialog
      open={open}
      onClose={() => setOpen(false)}
      aria-labelledby="confirmation-dialog"
      style={{ borderRadius: 0 }}
    >
      <Paper
        elevation={0}
        style={{
          padding: 16,
          textAlign: "center",
          width: 260,
          marginTop: -50,
          borderRadius: 0,
        }}
      >
        <Grid container direction="column">
          <Grid>
            <Typography
              style={{ fontSize: 20, marginTop: 55, fontWeight: 600 }}
            >
              {title}
            </Typography>
          </Grid>
          <Divider style={{ marginTop: 10, marginBottom: 10 }} />
          <Grid>
            {displayImage === undefined ? null : (
              <Grid>
                <img
                  style={{
                    width: "60%",
                    height: "60%",
                  }}
                  src={displayImage}
                />
              </Grid>
            )}
          </Grid>
          <Grid>
            {children === undefined
              ? ""
              : children.split("\n").map((i, key) => {
                  return (
                    <Typography key={key} style={{ minHeight: 20 }}>
                      {i.length > 0 ? i : "\u00A0"}
                    </Typography>
                  );
                })}
          </Grid>
          <Grid>
            {alert === undefined
              ? ""
              : alert.split("\n").map((i, key) => {
                  return (
                    <Typography
                      key={key}
                      style={{
                        minHeight: 20,
                        color: "#d1495b",
                        fontStyle: "italic",
                      }}
                    >
                      {i.length > 0 ? i : "\u00A0"}
                    </Typography>
                  );
                })}
          </Grid>
          <Grid container direction="row" style={{ marginTop: 20 }}>
            {cancelBtnLabel === "Hidden" ? (
              <Grid size={{ xs: 12}}>
                <Button
                  size="medium"
                  variant="contained"
                  color="primary"
                  onClick={() => {
                    setOpen(false);
                    onConfirm();
                  }}
                >
                  {confirmBtnLabel === undefined ? "Yes" : confirmBtnLabel}
                </Button>
              </Grid>
            ) : (
              <>
                <Grid size={{ xs: 6}} style={{ paddingLeft: 30 }}>
                  <Button
                    size="medium"
                    variant="contained"
                    color="primary"
                    onClick={() => {
                      setOpen(false);
                      onConfirm();
                    }}
                  >
                    {confirmBtnLabel === undefined ? "Yes" : confirmBtnLabel}
                  </Button>
                </Grid>
                <Grid size={{ xs: 6 }} style={{ paddingRight: 30 }}>
                  <Button
                    size="medium"
                    variant="contained"
                    color="secondary"
                    onClick={() => {
                      setOpen(false);
                      {
                        onCancel !== undefined ? onCancel() : "";
                      }
                    }}
                  >
                    {cancelBtnLabel === undefined ? "No" : cancelBtnLabel}
                  </Button>
                </Grid>
              </>
            )}
          </Grid>
        </Grid>
      </Paper>
    </Dialog>
  );
};

 ConfirmationDialog.propTypes = {
    title: PropTypes.string.isRequired,
    displayImage: PropTypes.string,
    children: PropTypes.string,
    alert: PropTypes.string,
    confirmBtnLabel: PropTypes.string,
    cancelBtnLabel: PropTypes.string,
    open: PropTypes.bool.isRequired,
    setOpen: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired,
    onCancel: PropTypes.func,
  };
